import { Helper } from '@/mixin/helper'
import store from '@/state/store'

export default [
  {
    path: '/liveview/',
    name: 'Liveview',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['b1a-default-liveview:read'])) {
          next()
        } else {
          const url = `${window.location.protocol}//${window.location.host}/liveview-2/`
          window.location.href = url
        }
      },
    },
    component: () => import(/* webpackChunkName: "liveview" */ '@/router/views/liveview/index'),
  },
]
